import AuthService from "../auth/AuthService";
import hbscan from "../../api/hbscan";
import IEslTemplate from "../../models/esl/eslTemplate";
import qs from "qs";

class EslTemplateService {
  GetEslTemplateById = async (id: string): Promise<IEslTemplate> => {
    const URI = `/api/hbscan/eslTemplate/GetEslTemplateById`;

    return (
      await hbscan.get<IEslTemplate>(URI, {
        headers: { Authorization: AuthService.guid },
        params: { id }
      })
    ).data;
  };

  GetEslTemplates = async (): Promise<IEslTemplate[]> => {
    const URI = `/api/hbscan/eslTemplate/GetEslTemplatesByCompanyId`;
    const companyId = AuthService.user?.companyId;

    return (
      await hbscan.get<IEslTemplate[]>(URI, {
        headers: { Authorization: AuthService.guid },
        params: { companyId }
      })
    ).data;
  };

  GetTemplateImageUrls = async (imageKeys: String[]) => {
    const url = '/api/hbscan/eslTemplate/GetTemplateImageUrls';
    return (
      await hbscan.get<Map<string, string>>(url, {
        headers: {
          Authorization: AuthService.guid,
          "Content-Type": 'application/json',
        },
        params: { imageKeys },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
    ).data;
  }

  CreateEslTemplate = async (template: IEslTemplate): Promise<string> => {
    const URI = `/api/hbscan/eslTemplate/CreateEslTemplate`;

    return (
      await hbscan.post<string>(URI, template, {
        headers: { Authorization: AuthService.guid }
      })
    ).data;
  }

  UpdateEslTemplate = async (template: IEslTemplate): Promise<void> => {
    const URI = `/api/hbscan/eslTemplate/UpdateEslTemplate`;

    return (
      await hbscan.put<void>(URI, template, {
        headers: { Authorization: AuthService.guid }
      })
    ).data;
  }

  UploadTemplateImages = async (images: FormData) => {
    const url = '/api/hbscan/eslTemplate/UploadTemplateImages';
    return (
      await hbscan.post<Map<number, string>>(url, images, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: AuthService.guid
        }
      })
    ).data;
  }

  DeleteEslTemplate = async (eslTemplateId: string): Promise<void> => {
    const URI = `/api/hbscan/eslTemplate/DeleteEslTemplate`;

    return (
      await hbscan.delete<void>(URI, {
        headers: { Authorization: AuthService.guid },
        params: { eslTemplateId }
      })
    ).data;
  }
}

const eslTemplateService = new EslTemplateService();

export default eslTemplateService;